import SettingsTabs from './settings-tabs';

export default SettingsTabs;
